import { slidesData } from '../slidesData';
import { seminaireSlidesData } from '../seminaireSlidesData';

/**
 * Registre des conférences.
 *
 * Chaque entrée est servie par `/conference/<id>`.
 * `/conference` (sans identifiant) reste câblée sur DEFAULT_CONFERENCE_ID
 * pour ne rien changer aux liens et aux habitudes existantes.
 *
 * Pour ajouter une conférence : créer son fichier de slides dans `src/data/`,
 * puis l'enregistrer ici. Rien d'autre à modifier.
 *
 * `logo` — chemin PUBLIC du logo affiché dans le bandeau du diaporama. C'est
 * une propriété de la CONFÉRENCE, pas du produit : le séminaire est donné chez
 * un client, sous la marque de l'employeur d'Adrien, et le logo GeoPolitikIA
 * n'y a rien à faire — il y était par héritage du deck d'origine. Une
 * conférence sans `logo` n'affiche simplement pas d'image (l'emplacement reste
 * réservé pour que le chapitre ne se décentre pas).
 *
 * `conducteur` — chemin PUBLIC du texte parlé, lu par le prompteur
 * (`/conference/<id>/prompteur`). Le fichier est copié depuis `docs/` par
 * `npm run conducteur`, lui-même déclenché par `npm run dev` : la copie ne peut
 * donc pas dériver de la source. Une conférence sans `conducteur` n'a pas de
 * prompteur, et le bouton ne s'affiche pas.
 *
 * `salle` — la session des questions de la salle (page `/q`) que le prompteur
 * compte dans son bandeau. `?salle=repetition` sur l'adresse du prompteur la
 * remplace le temps d'une répétition. Sans `salle`, pas de compteur.
 */
export const conferences = {
    architecte: {
        id: 'architecte',
        title: "De Codeur à Architecte d'Intention",
        logo: '/logoGeo.svg',
        slides: slidesData
    },
    seminaire: {
        id: 'seminaire',
        title: "L'IA n'accélère pas ce que vous croyez",
        logo: '/logoVIF.svg',
        slides: seminaireSlidesData,
        conducteur: '/conference/seminaire-CONDUCTEUR.md',
        salle: 'seminaire'
    }
};

export const DEFAULT_CONFERENCE_ID = 'architecte';

export const getConference = (id) => conferences[id] || conferences[DEFAULT_CONFERENCE_ID];
